import MainLayout from '../layouts/main';
import ExamsContainer from './container';

function ExamsPage() {
  return (
    <MainLayout title={EXAMS_PAGE_TITLE}>
      <ExamsContainer />
    </MainLayout>
  );
}

export const EXAMS_PAGE_TITLE = 'آزمون‌ها';

export default ExamsPage;
